var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft816(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3567 1.07505C7.68113 1.44181 7.68113 2.03643 7.3567 2.40318L2.40568 7.99999L7.3567 13.5968C7.68113 13.9635 7.68113 14.5582 7.3567 14.9249C7.03226 15.2917 6.50625 15.2917 6.18181 14.9249L0.643351 8.66405C0.318916 8.2973 0.318916 7.70268 0.643351 7.33592L6.18181 1.07505C6.50625 0.708299 7.03226 0.708299 7.3567 1.07505Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft816);
export default __webpack_public_path__ + "static/media/arrow-left-8-16.b6d2adeebd5c80eed70567c8dab4e040.svg";
export { ForwardRef as ReactComponent };